export var gridClass = function (size) {
    return "react-page-cell-sm-" + (size || 12) + " react-page-cell-xs-12";
};
//# sourceMappingURL=gridClass.js.map